<template>
    <component :is="spinner" :backgroundColor="backgroundColor" :color="color" :size="size" :dotSize="dotSize"></component>
</template>

<script>
/**
 * mt-spinner
 * @module components/spinner
 * @desc 加载动画
 * @param {(string)} [type=snake] - 显示类型，传入类型名或者类型 id，可选 `snake`, `dobule-bounce`, `triple-bounce`, `fading-circle`
 * @param {string} size - 尺寸
 * @param {string} color - 颜色
 *
 * @example
 * <spinner type="snake"></spinner>
 *
 * <!-- default snake -->
 * <spinner :size="30" color="#999"></spinner>
 */

import Snake from "./snake";
import TripleBounce from "./tripleBounce";
import FadingCircle from "./fadingCircle";
import FadingLine from "./fadingLine";

export default {
    name: "spinner",
    computed: {
        spinner() {
            return `${this.type}`;
        }
    },
    components: {
        Snake: Snake,
        TripleBounce: TripleBounce,
        FadingCircle: FadingCircle,
        FadingLine: FadingLine
    },
    props: {
        type: {
            type: String,
            default: "snake"
        },
        backgroundColor: {
            type: String,
            default: "transparent"
        },
        color: {
            type: String,
            default: "#ccc"
        },
        size: {
            type: String,
            default: "100%"
        },
        dotSize: {
            type: String,
            default: ""
        }
    }
};
</script>
